import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DesktopFilters, MobileFilters } from '../../components/RoomFilters/RoomFilters';
import { useRootStore } from '../../stores/useRootStore';
import { useRedirectToHomePage } from '../../useRedirectToHomePage';
import { RoomList } from './RoomsList';
import { RoomDetailsContext } from '../../Room/RoomDetails';

export const RoomsPage = observer(() => {
  const { paramsStore } = useRootStore();

  useRedirectToHomePage();

  const navigate = useNavigate();

  useEffect(() => {
    if (!paramsStore.appliedSearchParams) {
      navigate('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeRoomDetails = () => {
    navigate(-1);
  };

  const onRoomSelect = (roomId?: number) => {
    roomId && paramsStore?.selectRoom(Number(roomId));
    navigate('/rates');
  };

  const getRoom = (roomId: number) => paramsStore.getRoom(roomId);

  return (
    <>
      <RoomListFilters />
      <RoomDetailsContext.Provider
        value={{
          getRoom,
          rateMode: paramsStore.rateMode,
          onRoomSelect,
          closeRoomDetails: closeRoomDetails,
        }}
      >
        <RoomList
          roomList={paramsStore.roomList}
          nightsCount={paramsStore.nightsCount}
          isDisabled={paramsStore.hasUnappliedParams}
          onRoomSelect={onRoomSelect}
          onGoBack={() => navigate('/')}
        />
      </RoomDetailsContext.Provider>
    </>
  );
});

const RoomListFilters = () => {
  return (
    <>
      <div className="sticky top-0 z-10 hidden border-neutral-30 bg-neutral-0 xl:block xl:border">
        <div className="container mx-auto">
          <DesktopFilters />
        </div>
      </div>

      <div className="xl:hiddden">
        <MobileFilters />
      </div>
    </>
  );
};
